import React from 'react'
import { VStack, HStack, Text, Image, Separator } from '@chakra-ui/react'
import { buildAssetUrlString } from '@!/Util/buildAssetUrlString'
import StoreCoinSvg from '@images/store_coin.svg'

export const PurchaseResult = ({ purchasedCoinCount, price, totalCoinCount }) => (
  <VStack w="100%" bg="white" align="stretch" gap={0} borderRadius="4px" border="1px solid" borderColor="divider.light">
    {/* 購入コイン */}
    <HStack justify="space-between" align="center" px="16px" py="16px">
      <Text fontSize="md" fontWeight="600" color="label.primary" lineHeight="22px">
        購入コイン
      </Text>
      <HStack gap={1}>
        <Image w="20px" h="20px" src={buildAssetUrlString(StoreCoinSvg)} />
        <Text fontSize="md" fontWeight="600" color="label.primary" lineHeight="22px">
          {(purchasedCoinCount || 0).toLocaleString()}
        </Text>
      </HStack>
    </HStack>

    {/* 区切り線 */}
    <Separator />

    {/* 決済金額 */}
    <HStack justify="space-between" align="center" px="16px" py="16px">
      <Text fontSize="md" fontWeight="600" color="label.primary" lineHeight="22px">
        決済金額
      </Text>
      <Text fontSize="md" fontWeight="600" color="label.primary" lineHeight="22px">
        ¥{(price || 0).toLocaleString()}
        <Text as="span" fontSize="xs" fontWeight="400" ml="4px">
          (税込)
        </Text>
      </Text>
    </HStack>

    {/* 区切り線 */}
    <Separator />

    {/* 保有コイン */}
    <HStack justify="space-between" align="center" px="16px" py="16px">
      <Text fontSize="md" fontWeight="600" color="label.primary" lineHeight="22px">
        保有コイン
      </Text>
      <HStack gap={1}>
        <Image w="20px" h="20px" src={buildAssetUrlString(StoreCoinSvg)} />
        <Text fontSize="md" fontWeight="600" color="label.primary" lineHeight="22px">
          {(totalCoinCount || 0).toLocaleString()}
        </Text>
      </HStack>
    </HStack>
  </VStack>
)
